"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _FormField = require("../FormField/FormField.context");
var _ProgressBar = require("./ProgressBar.styles");
var _excluded = ["value", "minValue", "maxValue", "orientation", "size"];
/**
 * @related ['ProgressStepper']
 * @since 8.4.0
 */
var ProgressBar = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var value = _ref.value,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    orientation = _ref.orientation,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_FormField.FormFieldContext);

  // Used to set indicator bar styles. Also ensures % can't be less than 0
  // nor more than 100 */
  var percentComplete = 0;
  if (value >= maxValue) {
    percentComplete = 100;
  } else if (value > minValue && value < maxValue) {
    percentComplete = (value - minValue) / (maxValue - minValue) * 100;
  }
  return /*#__PURE__*/_react.default.createElement(_ProgressBar.StyledProgressBar, (0, _extends2.default)({
    role: "progressbar",
    value: value,
    minValue: minValue,
    maxValue: maxValue,
    orientation: orientation,
    size: size,
    "aria-describedby": context.descriptionId,
    "aria-labelledby": context.labelId,
    "aria-valuenow": value,
    "aria-valuemin": minValue,
    "aria-valuemax": maxValue,
    percentComplete: percentComplete,
    ref: forwardedRef
  }, rest));
});
exports.ProgressBar = ProgressBar;
ProgressBar.displayName = 'ProgressBar';
ProgressBar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional. The `id` of an element that provides information about the progress bar
   * beyond the `aria-label` or `aria-labelledby` label.
   *
   * When `ProgressBar` is used in a `FormField`, this value will automatically be set
   * to the `description` element's `id`.
   */
  'aria-describedby': _propTypes.default.string,
  /**
   * An accessible label for those using assistive technologies. Describes
   * the purpose of the progress bar.
   *
   * An accessible label is required and can be provided using either `aria-label` or
   * `aria-labelledby`.
   */
  'aria-label': _propTypes.default.string,
  /**
   * The `id` of the element that acts as an accessible label for those using
   * assistive technologies. The label should describe the purpose of the progress bar.
   *
   * When `ProgressBar` is used in a `FormField`, this value will automatically be set
   * to the `label` element's `id`.
   *
   * An accessible label is required and can be provided using either `aria-label` or
   * `aria-labelledby`.
   */
  'aria-labelledby': _propTypes.default.string,
  /**
   * The current progress value. Do not use a percentage. Instead, use a
   * number between the minValue and maxValue.
   */
  'value': _propTypes.default.number.isRequired,
  /**
   * The value when no progress has been made.
   */
  'minValue': _propTypes.default.number,
  /**
   * The value when progress has been completed.
   */
  'maxValue': _propTypes.default.number,
  /**
   * Displays either the horizontal or vertical version. Used by the vertical
   * `ProgressStepper`.
   *
   * Supports inline media query objects.
   *
   * @since 8.57.0
   * @ignore
   */
  'orientation': _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.ORIENTATIONS))),
  /**
   * Determines the height of the bar.
   */
  'size': _propTypes.default.oneOf(Object.values(_constants.PROGRESS_METER_SIZES))
} : {};
ProgressBar.defaultProps = {
  minValue: 0,
  maxValue: 100,
  orientation: _constants.ORIENTATIONS.horizontal,
  size: _constants.PROGRESS_METER_SIZES.sm
};